import { UseQueryResult } from "react-query";
import config from "config";
import { IdCollection, Measurement } from "types";
import { useScadaPlusQuery } from "hooks/useScadaPlusQuery";
import { getEnvConfig } from "env";

export type Capacity = {
  capacity: Measurement;
};

export const useGetCapacity = (
  ids: IdCollection,
  refreshInterval?: number,
): UseQueryResult<Capacity> => {
  return useScadaPlusQuery<Capacity>(
    `capacity-${ids.plantId}`,
    createUrlWithParams(ids),
    refreshInterval,
  );
};

const createUrlWithParams = (ids: IdCollection) => {
  const baseUrl = `${getEnvConfig("API_URL")}/api/${config.api.capacity}`;
  if (ids.sectionId) {
    return `${baseUrl}?SectionId=${ids.sectionId}`;
  }
  if (ids.plantId) {
    return `${baseUrl}?PlantId=${ids.plantId}`;
  } else {
    return `${baseUrl}?AllPlants=true`;
  }
};
